import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisApiService } from 'src/services/contentAnalysisApi'
import { ContentAnalysisActiveDateRange } from 'src/services/contentAnalysisApi/interfaces/contentAnalysis.interface'

interface UseGetContentAnalysisActiveDateRangeQueryParams {
  // Detail page: that analysis's own posts. Listing page (no id): every
  // analysis the user owns.
  analysisId?: string
  enabled: boolean
}

// The analysis's own first/last post date, for the top-bar picker's "Lifetime"
// preset on content-analysis routes. Mirrors
// useGetReviewAnalysisActiveDateRangeQuery — the account-wide range the picker
// defaults to spans SOCIAL-LISTENING mentions, which start whenever the
// account's first mention was found, not when its posts were published.
// Agrotechno's "GMC Motors" (posts from June) showed 2 posts of 5 under
// Lifetime because the account's mentions only went back to 9 August at the
// time — and the bound moved to March the moment older mentions were inserted.
export const useGetContentAnalysisActiveDateRangeQuery = ({
  analysisId,
  enabled,
}: UseGetContentAnalysisActiveDateRangeQueryParams) => {
  return useQuery({
    enabled,
    queryFn: (): Promise<ContentAnalysisActiveDateRange> =>
      ContentAnalysisApiService.getActiveDateRange(analysisId),
    queryKey: [QueryKey.GET_CONTENT_ANALYSIS_ACTIVE_DATE_RANGE, analysisId],
  })
}
